import { Component } from "react";
import TopNav from '../components/top_nav';
import Footer from '../components/footer';
import { ArrowRight } from "react-bootstrap-icons";

export default class CaseStudiesScreen extends Component {
    render() {
        return (
            <div>
                <TopNav />
                <div className="position-relative px-3 d-flex align-items-center hero-section">
                    <img
                        src="/case-study01.webp"
                        alt="case study"
                        className="img-fluid w-100 h-100 position-absolute top-0 start-0"
                        style={{ objectFit: "cover", zIndex: 1 }}
                    />

                    <div
                        className="position-absolute top-50 start-50 translate-middle text-white w-100 px-3 px-md-5 hero-content"
                        style={{ zIndex: 3 }}
                    >
                        <span className="badge rounded-pill bg-white border-primary-blue text-grey-color px-3 py-2 mb-2 mx-md-4">
                            <span className="me-2 text-success">●</span>Engineering What’s Next in Rail.
                        </span>

                        <div className="col-12 col-md-10 mx-md-4 mt-2">
                            <p className="hero-title">Explore how our solutions deliver measurable results.</p>
                        </div>
                        <div className="col-12 col-md-7 mx-md-4 mb-5">
                            <p className="hero-description">
                                Every challenge tells a story. Here’s how we solved them — with precision and purpose.
                            </p>
                        </div>
                        <div className="mx-md-4">
                            <button
                                onClick={() => {
                                    const section = document.getElementById("case-studies-section");
                                    section?.scrollIntoView({ behavior: "smooth" });
                                }}
                                className="btn d-flex align-items-center px-1 py-1 rounded-pill text-primary-blue bg-white"
                            >
                                <span className="mx-3 fs-14">Explore Our Case Studies</span>
                                <div
                                    className="d-flex justify-content-center align-items-center rounded-circle bg-primary-blue"
                                    style={{ width: '32px', height: '32px' }}
                                >
                                    <ArrowRight color="#ffffff" className='fs-12 fw-bold' />
                                </div>
                            </button>
                        </div>

                    </div>
                </div>




                <div className="row mx-0 justify-content-center mt-5" id="case-studies-section">
                    <div className="col-md-10 my-5">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="border-0">
                                    <img
                                        src="/case-study02.webp"
                                        className="rounded-4"
                                        alt="Yard Safety System"
                                        style={{ objectFit: "cover", maxHeight: "237px" }}
                                    />
                                </div>
                                <div className="fs-18 fw-semibold w-90 mt-3">
                                    Yard Safety Management System (YSMS)
                                </div>
                                <div className="fs-18 text-primary-blue w-90 fw-semibold mt-1">– Digital Rail Yard Transformation at a Steel Plant</div>
                                <p className="fs-14 mt-2 w-90">
                                    Seamless loco and torpido coordination,<br /> powered by smart automation.
                                </p>
                                <button
                                    onClick={() => window.location.href = "case-studies/case-study"}
                                    className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-2 bg-primary-blue"
                                >
                                    <span className="mx-3 fs-14">View Full Case Study</span>
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-circle"
                                        style={{
                                            width: '32px',
                                            height: '32px',
                                            backgroundColor: '#ffffff',
                                        }}
                                    >
                                        <ArrowRight color="#193E6C" />
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>






                <div className="container my-5">
                    <div className="  p-4 p-md-5 rounded-4">
                        <div className="row align-items-center">
                            {/* Text Section */}
                            <div className="col-md-6">
                                <span className="badge  fw-normal rounded-pill border-primary-blue text-primary-blue px-3 py-2 mb-3 fs-16">
                                    <span className="me-2 text-success fs-16">●</span>What we Do
                                </span>
                                <p className="fs-36 fw-bold mb-3">Tailored Solutions</p>
                                <p className="text-primary-blue">
                                    We partner with governments, rail operators, infrastructure owners, and engineering teams to deliver
                                    high-performance systems that meet the evolving demands of modern transportation. Whether it's new
                                    installations or upgrading legacy systems
                                </p>
                                <p className="fs-20 text-primary-blue">
                                    — We build solutions that scale with your vision.
                                </p>
                                <button
                                    onClick={() => window.location.href = "solutions"}
                                    className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-5 bg-primary-blue"
                                >
                                    <span className="mx-3 fs-14">Explore Our Solutions</span>
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-circle"
                                        style={{
                                            width: '32px',
                                            height: '32px',
                                            backgroundColor: '#ffffff',
                                        }}
                                    >
                                        <ArrowRight color="#193E6C" />
                                    </div>
                                </button>
                            </div>

                            <div className="col-md-6 text-center mt-4 mt-md-0">
                                <img
                                    src="/train.webp"
                                    alt="Train"
                                    className="img-fluid rounded-4 shadow-sm w-100 h-100"
                                    style={{ maxHeight: '350px', objectFit: 'cover' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        );
    }
}